// Global packages or components
import { useLoaderData } from '@remix-run/react'
import { resolveBlocks } from '~/.server'
import { getHire } from '~/sanity'
import { getMeta } from '~/utils'
import { Blocks, Breadcrumbs } from '~/components'
import { usePageInfo } from '~/hooks'

// Types
import type {
  MetaFunction,
  LoaderFunction,
  LoaderFunctionArgs,
} from '@remix-run/node'

// Route loader
export const loader: LoaderFunction = async ({
  request,
}: LoaderFunctionArgs) => {
  const env = process.env
  const url = new URL(request.url)

  // Sanity fetch
  const data = await getHire({
    dataset: env?.ENVIRONMENT,
    projectId: env?.SANITY_PROJECT,
  })

  // Page not found
  if (!data) {
    throw new Response('Not Found', {
      status: 404,
    })
  }

  // Server renders the product carousels
  const { blocks } = await resolveBlocks({
    blocks: data?.flexibleContent,
    request,
  })

  // Return data
  return Response.json({
    seo: data?.seo,
    blocks,
    path: url?.pathname,
  })
}

// Route meta
export const meta: MetaFunction = ({ matches, data }) => {
  return getMeta({
    matches,
    data,
  })
}

// Route view
export default function Index() {
  const { path, blocks } = useLoaderData<typeof loader>()

  usePageInfo({
    pageType: 'Page',
    pageTitle: 'Hire',
  })

  return (
    <main>
      <Breadcrumbs path={path} />
      <Blocks blocks={blocks} />
    </main>
  )
}
